import React from "react";

export const StatusPill = ({ status, theme }) => {
  const t = theme;
  const map = {
    paid: "border-emerald-500/40 text-emerald-500",
    pending_confirmation: "border-amber-500/40 text-amber-500",
    sent: `${t.rule} ${t.body}`,
    overdue: "border-rose-500/40 text-rose-500",
    draft: `${t.rule} ${t.muted}`,
  };
  const label = status === "pending_confirmation" ? "awaiting confirmation" : status;
  return (
    <span
      data-testid="invoice-status"
      className={`text-[10px] uppercase tracking-[0.18em] px-3 py-1 border ${map[status] || map.draft}`}
    >
      {label}
    </span>
  );
};
